var render = function render(){var _vm=this,_c=_vm._self._c;return _c('MainContentTabs',{attrs:{"tabs":[
        {tab : 'posiciones', nombre: 'Posiciones'},
    ],"initialTab":"posiciones","title":"Deportistas"}},[_c('template',{slot:"posiciones"},[_c('Posiciones')],1)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }